import { apiClient } from "api/trpc/trpc-client"
import Loader from "reusable/mobx-helpers/Loader"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { CopilotUsageTypeEnum } from "@gap/backend/app-services/copilot/models/CopilotUsageTypeEnum"

export default class DevAITokensStore {
   loader = new Loader(true)
   tokenUsage: { type: CopilotUsageTypeEnum, input: number, output: number }[] = []

   constructor() { }

   fetch = async () => {
      await this.loader.executeLoading(async () => {
         this.tokenUsage = await apiClient.gpt.getTotalTokenUsage.query()
      })
   }
}

export const { Provider: DevAITokensStoreProvider, useProvidedStore: useDevAITokensStore } = createStoreContext(DevAITokensStore)
